var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.16 1.951H9.757V.546l1.405 1.405zm.547.78V16H0V0h8.976v2.341c0 .215.175.39.39.39h2.341zm-1.56 11.318a.391.391 0 00-.39-.39H1.95a.39.39 0 000 .78h7.805a.39.39 0 00.39-.39zm0-2.342a.391.391 0 00-.39-.39H1.95a.39.39 0 000 .78h7.805a.39.39 0 00.39-.39zm0-2.341a.391.391 0 00-.39-.39H1.95a.39.39 0 000 .78h7.805a.39.39 0 00.39-.39zm0-2.342a.391.391 0 00-.39-.39H1.95a.39.39 0 000 .78h7.805a.39.39 0 00.39-.39zm0-2.341a.391.391 0 00-.39-.39H1.95a.39.39 0 000 .78h7.805a.39.39 0 00.39-.39z",
    fill: "#515864",
    fillRule: "nonzero"
  })));
}
export default SvgGuide;